export default __webpack_public_path__ + "static/media/MarvelousMotion_00.767e5a29.png";